import React from 'react';
import classes from './Logo.scss';

export default () => (
  <div className={classes['logo']}>
    <div className={classes['logo-image']}></div>
    <div className={classes['logo-text']}></div>
  </div>
);
